













export default {
  name: 'ExpandMenuIcon.vue',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
